import React from 'react'
import Feed from '../Feed'

export class Media extends React.PureComponent {
    render() {
        return (
            <section id="media" >
            <div className="media  d-flex justify-content-center align-items-center">
                <h2 className="text-white">Media</h2>
            </div>
            <div className="container">
            <Feed />
            </div>

        </section>
        )
    }
}
export default React.memo(Media)
